export default "/packs/images/abltythumb1~92bf0abaa92e9fe22a9e27eedd0412f9.png";